<template>
  <div id="chat-list-wrapper">
    <round-button-with-icon
      icon="plus"
      id="search-for-contact-button"
      @click="activateSearch"
    />
    <conversation-preview
      v-for="(conversation, index) in conversations"
      :key="index"
      :conversation="conversation"
      @click="navigateToConversation(conversation)"
    />
  </div>
</template>
<script>
import RoundButtonWithIcon from "../../UI/RoundButtonWithIcon.vue";
import ConversationPreview from "./ConversationPreview.vue";

export default {
  data() {
    return {};
  },
  computed: {
    conversations() {
      console.log(this.$store.getters.conversations);
      return this.$store.getters.conversations
        .filter((x) => {
          return Object.keys(x.messages).length > 0;
        })
        .sort((a, b) => {
          return Math.max(...Object.keys(a.messages)) >
            Math.max(...Object.keys(b.messages))
            ? -1
            : 1;
        });
    },
  },
  methods: {
    navigateToConversation(conversation) {
      this.$emit("navigate-to-conversation", conversation);
    },
    activateSearch() {
      this.$emit("navigate-to-search");
    },
  },
  components: { ConversationPreview, RoundButtonWithIcon },
  emits: ["navigate-to-conversation", "navigate-to-search"],
};
</script>
<style scoped>
#chat-list-wrapper {
  max-height: 100%;
  height: fit-content;
  padding: 10px;
  padding-top: 10px;
  box-sizing: border-box;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

#search-for-contact-button {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 2;
  background-color: var(--backgroundColor);
}

#search-for-contact-button:hover {
  filter: drop-shadow(0px 0px 2px var(--shadow));
}
</style>
